/**
 * Live lobby roster — who's seated, their role, ready state, and balance. Fed by
 * the server `roster` broadcast (presence). Uses framer-motion for join/leave.
 */

import { AnimatePresence, motion } from 'framer-motion';
import { useGameStore } from '../state/store';
import { BalanceCounter } from './BalanceCounter';

export function Roster() {
  const roster = useGameStore((s) => s.server.roster);
  const selfId = useGameStore((s) => s.serverAssignedId ?? s.identity?.clientId);

  return (
    <div className="panel roster">
      <h3 className="panel__title heading-gold">At the Table</h3>
      <ul className="roster__list">
        <AnimatePresence initial={false}>
          {roster.map((p) => (
            <motion.li
              key={p.id}
              layout
              initial={{ opacity: 0, x: -12 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 12 }}
              transition={{ duration: 0.22 }}
              className={`roster__row ${p.id === selfId ? 'is-self' : ''}`}
            >
              <span className={`roster__dot ${p.role}`} />
              <span className="roster__name">
                {p.name}
                {p.id === selfId ? ' (you)' : ''}
              </span>
              <span className="roster__meta">
                <span className={`roster__role role-${p.role}`}>
                  {p.role === 'croupier' ? 'Croupier' : 'Player'}
                </span>
                {p.ready && <span className="roster__ready">Ready</span>}
                <BalanceCounter cents={p.balanceCents} className="roster__balance" />
              </span>
            </motion.li>
          ))}
        </AnimatePresence>
        {roster.length === 0 && <li className="roster__empty">Waiting for players…</li>}
      </ul>
    </div>
  );
}
